import React, { cloneElement } from 'react';
import { Clock, Leaf, ShoppingCart, ClipboardList, FileText, Zap, Globe, Shield, Lock, CreditCard } from 'lucide-react';
const MOCKUP = 'https://cdn.magicpatterns.com/uploads/7LpXquXVjZ7Ez6nF2AUYAz/Mockup_fondo_Transparente.png';
export function HeroSection() {
  const benefits = [{
    icon: <Clock className="w-5 h-5" data-id="element-210" data-mp="28uo789db6d23" />,
    label: 'AHORRÁ TIEMPO'
  }, {
    icon: <Leaf className="w-5 h-5" data-id="element-211" data-mp="2wl0erj4n67s5" />,
    label: 'MENOS ESTRÉS'
  }, {
    icon: <ShoppingCart className="w-5 h-5" data-id="element-212" data-mp="30lkb4khe57d8" />,
    label: 'COMPRÁ MEJOR'
  }, {
    icon: <ClipboardList className="w-5 h-5" data-id="element-213" data-mp="2muffdth58z86" />,
    label: 'MÁS ORDEN'
  }];
  return <section className="relative bg-cosmic overflow-hidden px-4 pt-4 md:pt-8 pb-3 md:pb-6" data-id="element-214" data-mp="2rsqpm5bcpbqx">
      {/* Glow orbs */}
      <div className="absolute -top-32 -left-32 w-96 h-96 bg-orange/20 rounded-full blur-3xl pointer-events-none" data-id="element-215" data-mp="3fib9qrj8qf1s"></div>
      <div className="absolute -bottom-32 -right-32 w-96 h-96 bg-purple-600/20 rounded-full blur-3xl pointer-events-none" data-id="element-216" data-mp="3ka3297lyiuuk"></div>

      {/* Full-width title block — above the mockup on all screens */}
      <div className="relative max-w-6xl mx-auto text-center mb-3 md:mb-5" data-id="element-217" data-mp="2bf892pt5kxfe">
        <div className="inline-block bg-gold/15 border border-gold/40 text-gold px-4 py-1.5 rounded-full font-bold text-[13px] md:text-base tracking-wide uppercase mb-3 leading-snug text-center" data-id="element-218" data-mp="2p5lbydr6tlxv">
          <span className="block" data-id="element-219" data-mp="2z2q1mnk8rzjf">El sistema que organiza las viandas</span>
          <span className="block" data-id="element-220" data-mp="2u4ojq5yjy69j">cuando tus hijos viven entre 2 casas</span>
        </div>

        <h1 className="font-display font-black leading-[0.92] tracking-tight mb-1" data-id="element-221" data-mp="3847e7vyfxj3d">
          <span className="block text-white text-[48px] md:text-[96px]" data-id="element-222" data-mp="381tmnx2yyp0k">
            MEGAPACK VIANDA
          </span>
          <span className="block text-gold text-[48px] md:text-[96px]" data-id="element-223" data-mp="1dq6el8v2gs28">
            RESUELTA
          </span>
        </h1>

        <p className="italic text-white text-[13px] md:text-base leading-tight max-w-md mx-auto text-center" data-id="element-224" data-mp="18rv8n97w71pa">
          <span className="block" data-id="element-225" data-mp="38ucvioqya9jf">Todo resuelto para padres separados,</span>
          <span className="block" data-id="element-226" data-mp="3drw8llbwwg9s">sin estrés ni improvisación</span>
        </p>
      </div>

      <div className="relative max-w-6xl mx-auto grid lg:grid-cols-2 gap-2 md:gap-3 lg:gap-12 items-center" data-id="element-227" data-mp="3irqypmnv51ts">
        {/* Left text */}
        <div className="text-center lg:text-left order-2 lg:order-1" data-id="element-228" data-mp="3mtvsqmi840gy">
          <p className="text-gold/90 italic font-semibold text-lg md:text-xl mb-2" data-id="element-229" data-mp="3rsp8klkzg3ka">
            "Listo para usar. Sin pensar más."
          </p>
          <p className="text-white/85 md:text-lg mb-3 max-w-xl mx-auto lg:mx-0 text-[12px] leading-snug" data-id="element-230" data-mp="k1kvyz9s49k">
            <span className="block" data-id="element-231" data-mp="5de5ly0tvqx1">
              Organizá todas tus viandas escolares de una vez
            </span>
            <span className="block" data-id="element-232" data-mp="adieb1vhvhcp">
              sin improvisar ni perder las mañanas ni los domingos.
            </span>
          </p>

          {/* 4 mini benefit badges */}
          <div className="grid grid-cols-4 gap-1.5 mb-3 max-w-xs mx-auto lg:mx-0" data-id="element-233" data-mp="jcnbo4vbl4na">
            {benefits.map((b, i) => <div key={i} className="flex flex-col items-center text-center bg-white/5 backdrop-blur-sm border border-gold/30 rounded-md px-0.5 py-1" data-id="element-234" data-mp="1yvbhzp4wfggp" data-mpi={i}>
                <div className="w-5 h-5 rounded-full bg-gradient-to-br from-orange to-gold flex items-center justify-center text-white mb-0.5 shadow shadow-orange/30" data-id="element-235" data-mp="1pun3ktblfe3a">
                  {cloneElement(b.icon, {
                className: 'w-2.5 h-2.5'
              })}
                </div>
                <span className="text-white text-[9px] md:text-[10px] font-bold tracking-wider leading-tight" data-id="element-236" data-mp="2dsm37q7cg0pm">
                  {b.label}
                </span>
              </div>)}
          </div>

          <div className="flex justify-center lg:justify-start" data-id="element-237" data-mp="368n1xzusivof">
            <a href="https://megapack-vianda-resuelta.impultienda.ar/checkout" className="cta-btn inline-flex items-center justify-center text-white font-display font-extrabold text-base md:text-lg uppercase tracking-wide px-8 md:px-10 py-4 rounded-full" data-id="element-238" data-mp="36azqwwyyu6az">
              🍱 QUIERO MI MEGAPACK AHORA
            </a>
          </div>

          <p className="font-script text-gold md:text-xl mt-3 text-[18px]" data-id="element-239" data-mp="2c3aocsaiuo41">
            Más orden, menos estrés, más tiempo para vos.
          </p>
        </div>

        {/* Right mockup */}
        <div className="order-1 lg:order-2 relative flex justify-center" data-id="element-240" data-mp="34rpraggdpfz0">
          <img src={MOCKUP} alt="MegaPack Vianda Resuelta - Producto completo" className="relative w-full max-w-[220px] md:max-w-[280px] mx-auto drop-shadow-[0_20px_60px_rgba(245,166,35,0.4)]" data-id="element-241" data-mp="38srsv3xrq445" />
        </div>
      </div>

      {/* Trust bar — moved below the mockup, smaller */}
      <div className="relative max-w-5xl mx-auto mt-3 md:mt-5" data-id="element-242" data-mp="3nohgf6ilqpaz">
        <div className="flex flex-nowrap justify-center items-center gap-x-1 md:gap-x-2 text-[8px] md:text-xs text-white/70 whitespace-nowrap" data-id="element-243" data-mp="3sfz8f52ndfjt">
          <span className="flex items-center gap-0.5 md:gap-1" data-id="element-244" data-mp="5oc3bnn33oh1">
            <Zap className="w-2 h-2 md:w-3 md:h-3 text-gold shrink-0" data-id="element-245" data-mp="1ol9tc66au8t" /> Acceso
            inmediato
          </span>
          <span className="text-white/20" data-id="element-246" data-mp="feev5kigywds">|</span>
          <span className="flex items-center gap-0.5 md:gap-1" data-id="element-247" data-mp="fhat38ubhl28">
            <Shield className="w-2 h-2 md:w-3 md:h-3 text-gold shrink-0" data-id="element-248" data-mp="agwx4p5zq1kk" />{' '}
            Garantía 7 días
          </span>
          <span className="text-white/20" data-id="element-249" data-mp="3iy9js1s9k7po">|</span>
          <span className="flex items-center gap-0.5 md:gap-1" data-id="element-250" data-mp="3evd9cycvnhwt">
            <Lock className="w-2 h-2 md:w-3 md:h-3 text-gold shrink-0" data-id="element-251" data-mp="3sucuvx53fgor" /> Pago
            seguro
          </span>
          <span className="text-white/20" data-id="element-252" data-mp="3nvjfu0a5rhmh">|</span>
          <span className="flex items-center gap-0.5 md:gap-1" data-id="element-253" data-mp="3ntowurig5zl1">
            <CreditCard className="w-2 h-2 md:w-3 md:h-3 text-gold shrink-0" data-id="element-254" data-mp="183cfrua5l59p" />{' '}
            Pagás en tu moneda
          </span>
        </div>
      </div>
    </section>;
}